import React, { useEffect, useState, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import { useHistory, Link } from "react-router-dom";
import { toggleSidebar } from "../../redux/SidebarAction";
import {
  stringIsNullOrEmpty,
  isObjectEmpty,
  numberWithCurrencyFormat,
  createFormBody,
  createMultiPartFormBody
} from "../../util/Util";
import {
  WebUrl,
  ApiUrl,
  ApiKey,
  LanguageOption,
  SessionKey,
  Language,
  LanguageSelectStyle,
  getReferralCodeByDomain,
  AlertTypes
} from "../../util/Constant";
import { Dropdown, DropdownItem, DropdownMenu, DropdownToggle } from "reactstrap";
import { saveLanguageId } from "../../redux/LanguageAction";
import ApiEngine from "../../util/ApiEngine.js";
import {
	setBusy,
	setIdle,
	showMessage,
	showResponseMessage,
  setLoginModal,
  setRegisterModal
} from "../../redux/AppAction.js";
import { find, isEmpty, map, upperCase } from "lodash";
import { themeIcons } from "config/theme";
import VIcon from "components/custom/Icon";


const DesktopHeader = () => {
  var { t, i18n } = useTranslation();
  const _history = useHistory();
   var _dispatch = useDispatch();

  const authState = useSelector((state) => state.authState);
  const _userData = useSelector((state) => state.authState.userData);
  const memberData = useSelector((state) => state.appState.member);
  const search = window.location.search;
  const params = new URLSearchParams(search);
  const [activeLanguage, setActiveLanguage] = useState(
      localStorage.getItem(SessionKey._LANGUAGE) || "EN"
    );
  const [activeLanguageId, setActiveLanguageId] = useState(1);
  const [selectionLangHeaderOption, setSelectionLangHeaderOption] = useState(
    []
  );
  const [dropdownLanguageOpen, setDropdownLanguageOpen] = useState(false);
  const [languageSelected, setLanguageSelected] = useState({
    name: "ខ្មែរ",
    code: "kh",
  });
  const [unreadNotification, setUnreadNotification] = useState(false);

  const countryList = [
    {
      name: "Cambodia",
      iso: "LANG",
      // icon: require("../assets/img/v3/my.png"),
      url: window.location.origin,
      child_languages: [
        {
          name: "English",
          languageCode: Language._ENGLISH,
          languageId: 1,
        },
        {
          name: "Khmer",
          languageCode: Language._KHMER,
          languageId: 2,
        },
        {
          name: "中文",
          languageCode: Language._CHINESE,
          languageId: 3,
        },
        {
          name: "Tiếng Việt",
          languageCode: Language._VIETNAMESE,
          languageId: 4,
        },
        {
          name: "Indo",
          languageCode: Language._INDON,
          languageId: 5,
        },
      ],
    },
  ];
  useEffect(() => {
    // let initSelectionOption = countryList.filter((x) => x.iso == "LANG")[0];
    // setSelectionLangHeaderOption(initSelectionOption);
    if (params.get("languageCode") != null) {
      changeLanguage(params.get("languageCode"));
      setActiveLanguage(params.get("languageCode"));
      let tempLangId = LanguageOption.filter(
        (x) => x.code == params.get("languageCode")
      )[0].languageId;
      setActiveLanguageId(tempLangId);
      localStorage.setItem(SessionKey._LANGUAGE, params.get("languageCode"));
    } else if (
      localStorage.getItem(SessionKey._LANGUAGE) &&
      localStorage.getItem(SessionKey._LANGUAGE) !== "undefined"
    ) {
      let tempLangId = LanguageOption.filter(
        (x) => x.code == localStorage.getItem(SessionKey._LANGUAGE)
      )[0].languageId;
      setActiveLanguageId(tempLangId);
      setActiveLanguage(localStorage.getItem(SessionKey._LANGUAGE));
    } else {
      localStorage.setItem(SessionKey._LANGUAGE, "kh");
      setActiveLanguage("kh");
      setActiveLanguageId(2);
    }


    onClickLanguage(localStorage.getItem(SessionKey._LANGUAGE) ?? Language._KHMER)

    // console.log(authState)

  }, []);

  useEffect(() => {
  if (memberData["username"]) {
    isAnyUnreadNotification();
  }
  }, [memberData]);

  const changeLanguage = async (selectedLanguage) => {
		i18n.changeLanguage(selectedLanguage);
		_dispatch(saveLanguageId(selectedLanguage));
		let tempLangId = LanguageOption.filter((x) => x.code == selectedLanguage)[0]
			.languageId;
		// setActiveLanguage(selectedLanguage);
		// setActiveLanguageId(tempLangId);
		localStorage.setItem(SessionKey._LANGUAGE, selectedLanguage);
		if (authState.isLoggedIn) {
			let params = {
				languageSetting: selectedLanguage,
			};
			let langJson = await ApiEngine.post(
				ApiUrl._API_UPDATE_MEMBER_LANGUAGE,
				createFormBody(params)
			);
			if (!langJson[ApiKey._API_SUCCESS_KEY]) {
				_dispatch(showMessage(false, t("ERROR_SAVING_LANGUAGE_TO_MEMBER")));
			}
		}
	};
	const toggleLanguageDropDown = () => setDropdownLanguageOpen((prevState) => !prevState);
	const onClickLanguage = (value) => {
		let findLanguage = find(LanguageOption, { value: value });
	
		setLanguageSelected(findLanguage);
		changeLanguage(value);
	
	};
  async function isAnyUnreadNotification() {
    let responseJson = await ApiEngine.get(
      ApiUrl._API_CHECK_ANY_UNREAD_NOTIFICATION +
      "?LanguageId=" +
      memberData["languageSetting"]
    );
    if (responseJson[ApiKey._API_SUCCESS_KEY]) {
      setUnreadNotification(responseJson[ApiKey._API_DATA_KEY]);
    }
  }

  const handleToggleSidebar = () => {
    _dispatch(toggleSidebar());
  };

  const handleOpenRegister = () => {
    const domainCode = getReferralCodeByDomain(window.location.hostname);
    if (domainCode){
      const registerUrl = WebUrl._URL_MLMCREATEANACCOUNT + "?code=" + (domainCode ?? "");
      _history.push(registerUrl);
    }
    else{
      _dispatch(setRegisterModal(true));
    }
  };

  const handleScrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth", // optional: for smooth scrolling
    });
  };

  return (
    <>
      <header className="responsive-header">
        <div className="header-container">
          <div className="header-left">
            <div className="hamburger-menu" onClick={handleToggleSidebar}>
              <img
                src={require("../../assets/img/desktop/hamburger.png")}
                className="img-responsive"
                alt="okup hamburger"
                loading="lazy"
              />
            </div>
            <div className="logo">
              <Link to={{ pathname: WebUrl._URL_MAIN }}>
                {memberData.length == 0 ? (
                  <img
                    src={
                      require("../../assets/img/logobig2.png")
                    }
                    className="img-responsive"
                    style={{ height: "40px" }}
                    alt="logo"
                    loading="lazy"
                  />
                ) : (
                  <img
                    src={
                      !stringIsNullOrEmpty(memberData["logo"])
                        ? memberData?.["logo"]
                        : require("../../assets/img/logobig2.png")
                    }
                    className="img-responsive"
                    style={{ height: "40px" }}
                    alt="logo"
                    loading="lazy"
                  />
                )}
              </Link>
            </div>
          </div>

          <div className="header-right">
            {authState.isLoggedIn ? (
              <>
                <div className="header-balance-deposit-box">
                  <div className="balance-btn">
                    <div
                      style={{
                        cursor: "pointer",
                        display: "flex",
                        alignItems: "center",
                        position: "relative",
                      }}
                    >
                      <div className="header-balance-column">
                        <span className="font-size-header-balance">
                          {t("BALANCE")}:
                        </span>
                        <b className="font-size-header-balance balance-amount">
                          {numberWithCurrencyFormat(
                              parseFloat(authState.userData.walletBalance)+parseFloat(authState.userData.tempPrimaryCredit)+parseFloat(authState.userData.bonusBalance)+parseFloat(authState.userData.tempBonusWallet),
                              2,
                              true
                            )}
                        </b>
                      </div>
                    </div>
                  </div>
                  <div
                    className={"header-deposit " + ((_userData.bonusBalance+_userData.tempBonusWallet) > 0 ? "disabled" : "")}
                    onClick={() => {
                      if((_userData.bonusBalance+_userData.tempBonusWallet) > 0){
                         _dispatch(
                            showMessage({
                                type: AlertTypes._WARNING,
                                content: t("PLEASE_END_PROMOTION_TO_CONTINUE"),
                            })
                          );
                      } else {
                        _history.push(WebUrl._URL_DEPOSIT);
                        handleScrollToTop();
                      }
                    }}
                  >
                    <div>
                      <img
                        src={require("../../assets/img/desktop/icon-deposit.png")}
                        className="img-responsive"
                        alt="okup"
                        loading="lazy"
                      />
                    </div>
                    <div className="text">{t("DEPOSIT")}</div>
                  </div>
                </div>

                {/* User Profile */}
                <div
                  className="header-profile-box"
                  onClick={() => {
                    _history.push(WebUrl._URL_SETTINGS);
                    handleScrollToTop();
                  }}
                >
                  <div className="second">
                    <div>{authState.userData["username"]}</div>
                      <div>
                        <span>{t("VIP")} </span> : {t(upperCase(authState.userData["vipName"]))}
                      </div>
                  </div>
                  <div className="third">
                    <svg
                      focusable="false"
                      color="#ffffff"
                      aria-hidden="true"
                      viewBox="0 0 24 24"
                      data-testid="ExpandMoreIcon"
                      fill="white"
                      height="20px"
                    >
                      <path d="M8.59 16.59 13.17 12 8.59 7.41 10 6l6 6-6 6z"></path>
                    </svg>
                  </div>
                </div>
              </>
            ) : (
              <>
                {/* Authentication Buttons */}
                {!authState.isLoggedIn ? (
                    <div className="authenticate-container" style={{ fontWeight: "bold", backgroundColor: "transparent" }}>
                      <div className="cursor-pointer" onClick={() =>  _dispatch(setLoginModal(true))}>{t('LOGIN')}</div>
                      <div className="cursor-pointer register" onClick={() =>  handleOpenRegister()}>{t('REGISTER')}</div>
                    </div>) : ""
                }
              </>
            )}

            {/* Notification Icon */}
            {authState.isLoggedIn && (
              <div
                className="dashboard-noti"
                onClick={() => _history.push(WebUrl._URL_NEWS)}
                style={{ cursor: "pointer" }}
              >
                {unreadNotification ? (
                  <div className="header-notif-box">
                    <VIcon
                      icon={themeIcons.dashboardNotification}
                      className="theme-icon-size-20"
                    />
                    <div className="notif-red"></div>
                  </div>
                ) : (
                  <div className="header-notif-box">
                    <VIcon
                      icon={themeIcons.dashboardNotification}
                      className="theme-icon-size-20"
                    />
                  </div>
                )}
              </div>
            )}
            

            {/* Language Selector */}
            <Dropdown
              className="language-dropdown"
              isOpen={dropdownLanguageOpen}
              toggle={toggleLanguageDropDown}
              direction={"down"}
            >
              <DropdownToggle>
                <div className="language-drowpdown-btn">
                    <img src={`/images/${languageSelected.code}.png`} alt={languageSelected.code} width="20" height="20" loading="lazy"/>
                    <div>
                      {languageSelected.code}
                      <img
                        src={require("../../assets/img/desktop/carret-down.png")}
                        className="img-responsive"
                        alt="okup"
                        loading="lazy"
                      />
                    </div>
                </div>
                </DropdownToggle>
                <DropdownMenu>
                {map(LanguageOption, (item, index) => {
                  return (
                  <DropdownItem key={item.value} onClick={() => onClickLanguage(item.value)}>
                    <img src={`/images/${item.code}.png`} alt={item.code} width="20" height="20" loading="lazy"/> <span className="ml-1">{item.name}</span>
                  </DropdownItem>
                  );
                })}
    
                </DropdownMenu>
            </Dropdown>
          </div>
        </div>
      </header>
    </>
  );
};

export default DesktopHeader;